import type { ChecklistOption } from '../components/checklist';
import { ChecklistGroup, ChecklistItem } from '../components/checklist';
import { Expandable } from '../components/expandable';
import { createFilter } from '../create-filter';
import { type FilterProps } from '../types';
import { arrayFilterMethods } from '../utils';

export type ChecklistControlProps<T> = FilterProps<
  T[],
  {
    options: ChecklistOption<T>[];
  }
>;

export const ChecklistControl = createFilter(function UnboundChecklistControl<
  T = string
>({ options, filter }: ChecklistControlProps<T>) {
  const { hasSelectedValue, toggleSelectedValue } = arrayFilterMethods(filter);

  return (
    <Expandable
      items={options}
      limit={6}
      itemsContainer={ChecklistGroup}
      renderItem={(option) => (
        <ChecklistItem
          key={option.label}
          selected={hasSelectedValue(option.value)}
          onToggle={() => toggleSelectedValue(option.value)}
          label={option.label}
          description={option.description}
        />
      )}
    />
  );
});
